import OtherPageFormat from "../components/OtherPageFormat";

const OrderPage = () => {
  return (
    <div className="bg-red-200 h-4/5">
      <OtherPageFormat title={"Order"} />
    </div>
  );
};

export default OrderPage;
